import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TenantService } from "projects/shared/src/lib/services/tenant.service";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridUsersSettings {

  constructor(private translate: TranslateService, private tenantService: TenantService, private deletable: boolean) { }

    getRowStyle = (params: any) => {
      if (params.data && _.get(params.data, 'lockoutEnabled', '') === true) {
        return { 'background-color': '#eba3aa', 'color': 'black' };
      }
        return { 'background-color': 'white', 'color': 'black' };
    };

    public agGridUsersSettings = {
      rowModelType: 'infinite',
      rowSelection: 'single',
      rowHeight: 55,
      enableRangeSelection: true,
      cacheBlockSize: 10000,
      cacheOverflowSize: 2,
      maxConcurrentDatasourceRequests: 1,
      paginationPageSize: 30,
      infiniteInitialRowCount: 0,
      getRowStyle: (params: any) => this.getRowStyle(params),
      columnDefs: [
        {
          headerName: `${this.translate.data["USERSUSERNAMECOLUMNHEADER"]}`,
          sortable: true,
          filter: true,
          valueGetter: (params: any) => {
            console.log("-----------> Benutzername: ", params.data);
            const lastName = _.get(params.data, 'last_Name', '')?.trim();
            const userName = (lastName !== '(not confirmed)') ? _.get(params.data, 'first_Name', '') + ' ' + _.get(params.data, 'last_Name', '')
              : "(not confirmed)";
            return userName;
          },
        },
        { field: 'email', headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`, sortable: false, filter: false },
        {
          width: 500,
          headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            icon_edit: 'edit',
            icon_view: 'visibility',
            icon_delete: (this.deletable) ? 'delete' : '',
            routerLinkEditUser: (params: ICellRendererParams) => `/user-profile/${_.get(params, 'data.id')}`,
            routerLinkViewUser: (params: ICellRendererParams) => `/${this.tenantService.currentTenantName}/manage-users/${_.get(params, 'data.id')}`
          },
        },
      ],
      defaultColDef: {
        flex: 1,
        resizable: true,
        minWidth: 100,
        editable: false
      }
    }

}